import './orchestrators/loadThemeOrchestrator';
import './orchestrators/setCalendarColorSchemeMutator';

export {
    getCalendarColorSchemeByFolderId,
    getCalendarEventColorScheme,
    getCalendarColorScheme,
    refreshAssignedColorScheme,
    isCalendarColorResolved,
} from './utils/CalendarColorResolver';
export {
    getDefaultColorSchemes,
    initializeDefaultColorSchemes,
    getColorSchemeForHexColor,
    getDefaultColorSchemesOrderedByColorIndex,
} from './utils/CalendarColorSchemes';
